import { URLs } from "../url";
import { CatalogueResponse } from "../../model/catalogue";
import { getHeader } from "../headers";
import { handleUnauthorized } from "../fetchRequest";

const getGeneralCatalog = async (
  clientId: string,
  enable: boolean,
  page: number,
  limit: number,
  type: string,
  code: string,
  description: string,
) => {
  let newURL =
    process.env.REACT_APP_HOST_API +
    URLs.catalog +
    `?clientId=${clientId}` +
    `&enable=${enable}&page=${page}&limit=${limit}` +
    (type ? `&type=${type}` : "") +
    (code ? `&code=${code}` : "") +
    (description ? `&description=${description}` : "");

  const requestOptions = {
    method: "GET",
    headers: getHeader(),
  };

  try {
    const response = await fetch(newURL, requestOptions);
    if (!response.ok) {
      handleUnauthorized(response.status);
      throw await response.json();
    }
    return (await response.json()) as CatalogueResponse;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

const postGeneralCatalog = async (body: any) => {
  const newURL = process.env.REACT_APP_HOST_API + URLs.catalog;
  const requestOptions = {
    method: "POST",
    body: JSON.stringify({ data: body }),
    headers: getHeader(),
  };

  try {
    const response = await fetch(newURL, requestOptions);
    if (!response.ok) {
      handleUnauthorized(response.status);
      throw await response.json();
    }
    return (await response.json()) as CatalogueResponse;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

const patchGeneralCatalog = async (body: any, id: string) => {
  let newURL = process.env.REACT_APP_HOST_API + URLs.catalog + `/${id}`;
  const requestOptions = {
    method: "PATCH",
    body: JSON.stringify({ data: body }),
    headers: getHeader(),
  };

  try {
    const response = await fetch(newURL, requestOptions);
    if (!response.ok) {
      handleUnauthorized(response.status);
      throw await response.json();
    }
    return (await response.json()) as CatalogueResponse;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export { getGeneralCatalog, postGeneralCatalog, patchGeneralCatalog };
